module.exports = __webpack_public_path__ + "static/media/arrow-left.d6697690.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/arrow-left.svg
 ** module id = 51
 ** module chunks = 0
 **/